import React from 'react';
import { PrismicLink } from 'components/PrismicLink';
import { useAuthentication } from 'components/Authentication';
import { PrismicLinkTypes } from 'components/Slices/enums';

interface LogInLogOutProps {
    loginLabel: string;
    logoutLabel: string;
    className: string;
}

export const LogInLogOut: React.FC<LogInLogOutProps> = ({ loginLabel, logoutLabel, className }) => {
    const { isAuthenticated, loginUrl, logout } = useAuthentication();

    return !isAuthenticated ? (
        <PrismicLink
            label={loginLabel}
            link={{
                _linkType: PrismicLinkTypes.external,
                url: loginUrl,
                target: '_self',
            }}
            className={className}
        />
    ) : (
        <a className={className} onClick={logout}>
            {logoutLabel}
        </a>
    );
};
